import React, { useEffect, useRef, useState } from 'react';
import { SingleValueProps, components } from 'react-select';

import { CustomTooltip } from 'common/components/CustomTooltip/CustomTooltip.styled';

const getSingleValueLabel = (props: any) => {
  const selectedOption = props?.getValue?.()?.[0];

  if (typeof selectedOption?.label === 'string') {
    return String(selectedOption.label);
  }

  return '';
};

const SingleValueWithEllipsisTooltip = (props: SingleValueProps<any>) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLDivElement | null>(null);
  const label = getSingleValueLabel(props);
  const tooltipId = `selectSingleValueTooltip_${props.selectProps?.name}`;

  const updateTruncation = () => {
    if (!textRef.current) {
      setIsTruncated(false);

      return;
    }

    const truncated = textRef.current.scrollWidth > textRef.current.clientWidth;
    setIsTruncated(truncated);

    if (truncated) {
      requestAnimationFrame(() => CustomTooltip.rebuild());
    }
  };

  useEffect(() => {
    updateTruncation();
  }, [label]);

  if (!label) {
    return <components.SingleValue {...props}>{props.children}</components.SingleValue>;
  }

  return (
    <components.SingleValue {...props}>
      <div
        ref={textRef}
        onMouseEnter={updateTruncation}
        data-for={isTruncated ? tooltipId : undefined}
        data-tip={isTruncated ? label : undefined}
        style={{
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {props.children}
      </div>
    </components.SingleValue>
  );
};

export const singleValueTooltipComponents = {
  SingleValue: SingleValueWithEllipsisTooltip,
};

export const SingleValueTooltip = ({ name }: { name?: string }) => (
  <CustomTooltip place="top" effect="solid" id={`selectSingleValueTooltip_${name}`} />
);
